import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { StandardChecklistDto } from 'app/api/models/employee/standardChecklistDto';
import { EmployeeTodoService } from 'app/api/services/employeeTodos.serive';

@UntilDestroy()
@Component({
  selector: 'app-checklist-page',
  templateUrl: './tenant-checklist-page.component.html',
  styleUrls: ['./tenant-checklist-page.component.scss'],
  standalone: false,
})
export class TenantChecklistPageComponent implements OnInit {
  data: StandardChecklistDto[] = [];
  filterSearchText: string = '';
  filteredData: StandardChecklistDto[] = [];
  editedChecklist: StandardChecklistDto | null = null;
  showDialog: boolean = false;
  id!: string | null;
  loading = false;
  deleteConf: { id: string; name: string } | null = null;

  constructor(
    private service: EmployeeTodoService,
    private route: ActivatedRoute,
  ) {}

  ngOnInit() {
    this.route.paramMap.subscribe({
      next: (value) => {
        this.id = value.get('id')!;
        if (this.id) {
          this.loadChecklists(this.id);
        }
      },
    });
  }

  loadChecklists(id: string) {
    this.service
      .getStandardChecklists(id)
      .pipe(untilDestroyed(this))
      .subscribe((data) => {
        this.data = data;
        console.log(data);

        this.applyFilters();
      });
  }

  applyFilters() {
    this.filteredData = this.data.filter((checklist) => {
      if (this.filterSearchText) {
        return checklist.title
          .toLowerCase()
          .includes(this.filterSearchText.toLowerCase());
      }

      return true;
    });
  }

  closeModal() {
    this.showDialog = false;
    this.loadChecklists(this.id!);
  }

  exportToExcel(): void {
    this.service.exportChecklists(this.id!).subscribe((blob) => {
      const a = document.createElement('a');
      const objectUrl = URL.createObjectURL(blob);
      a.href = objectUrl;
      a.download = `Checklists_${this.id!}.xlsx`;
      a.click();
      URL.revokeObjectURL(objectUrl);
    });
  }

  showModalWindow() {
    this.showDialog = true;
  }

  handleDeleteClick(id: string) {
    this.service
      .deleteStandardChecklist(id)
      .pipe(untilDestroyed(this))
      .subscribe(() => {
        this.loadChecklists(this.id!);
      });
  }
}
